/**
 * Team kit / leaderboard / profile-display helpers (sessionStorage from team selection + settings).
 */

export const DEFAULT_KIT_COLOUR = '#9f1717';
export const DEFAULT_PROFILE_SHIRT_COLOUR = '#bd1313';
export const WHITE_SHIRT_COLOUR = '#ffffff';

const BOOL_SETTINGS = [
  ['hide_leaderboard', 'selected_team_hide_leaderboard'],
  ['hide_wins_draws_losses', 'selected_team_hide_wins_draws_losses'],
  ['hide_player_ratings', 'selected_team_hide_player_ratings'],
];

function asBooleanFlag(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

function readSessionFlag(key) {
  const flag = sessionStorage.getItem(key);
  return flag === 'true' || flag === '1';
}

export function getTeamKitColour(fallback = DEFAULT_KIT_COLOUR) {
  const stored = sessionStorage.getItem('selected_team_kit_colour');
  if (stored && /^#[0-9A-Fa-f]{6}$/i.test(stored)) {
    return stored.toLowerCase();
  }
  return fallback;
}

/** Coloured shirt used on profile / Colour kit (not White). */
export function getColouredShirtColour() {
  return getTeamKitColour(DEFAULT_PROFILE_SHIRT_COLOUR);
}

export function isLeaderboardHidden() {
  return readSessionFlag('selected_team_hide_leaderboard');
}

export function isWinsDrawsLossesHidden() {
  return readSessionFlag('selected_team_hide_wins_draws_losses');
}

export function isPlayerRatingsHidden() {
  return readSessionFlag('selected_team_hide_player_ratings');
}

export function applyTeamSettingsToSession(settings = {}) {
  BOOL_SETTINGS.forEach(([field, storageKey]) => {
    if (typeof settings[field] !== 'undefined') {
      sessionStorage.setItem(storageKey, asBooleanFlag(settings[field]) ? 'true' : 'false');
    }
  });
  if (Object.prototype.hasOwnProperty.call(settings, 'kit_colour')) {
    const colour = settings.kit_colour;
    if (colour && /^#[0-9A-Fa-f]{6}$/i.test(colour)) {
      sessionStorage.setItem('selected_team_kit_colour', colour.toLowerCase());
    } else {
      sessionStorage.removeItem('selected_team_kit_colour');
    }
  }
}

export function applyTeamRowToSession(team = {}) {
  applyTeamSettingsToSession({
    hide_leaderboard: team.hide_leaderboard,
    hide_wins_draws_losses: team.hide_wins_draws_losses,
    hide_player_ratings: team.hide_player_ratings,
    kit_colour: team.kit_colour,
  });
}
